<template>
  <div>
    <v-list dense nav>
      <v-list-item>
        <v-list-item-content>
          <v-img height="40px" contain :src="require('@/assets/logo.png')"></v-img>
        </v-list-item-content>
      </v-list-item>

      <v-subheader>Trips</v-subheader>
      <v-list-item :to="{ name: 'Trips' }">
        <v-list-item-icon>
          <v-icon>mdi-earth</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>My Trips</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-divider></v-divider>
    <TripDrawer v-if="trip" />
    <v-divider v-if="trip"></v-divider>
    <v-subheader>Company</v-subheader>
    <v-list dense nav>
      <v-list-group v-for="(company, index) in companies" :key="company.id" :value="true" no-action>
        <template v-slot:activator>
          <v-list-item>
            <v-list-item-avatar v-if="companyImage(company.id)" tile>
              <v-img contain :src="companyImage(company.id)"></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ company.name }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <v-list-item
          :to="{ name: 'CompanyTrips', params: { index: index, companyId: company.id } }"
        >
          <v-list-item-icon>
            <v-icon>mdi-earth</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Trips</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          :to="{ name: 'Company', params: { index: index, companyId: company.id } }"
          v-if="
            company.owner === userId ||
            company.id === 'OaaRuxV6tA3nobp42xMq' ||
            company.id === 'R1XBW59p2FFxo5WudH3H'
          "
        >
          <v-list-item-icon>
            <v-icon>mdi-cog</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Settings</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </v-list>
  </div>
</template>

<script>
import TripDrawer from "./TripDrawer";

export default {
  name: "NavDrawer",
  components: { TripDrawer },
  data() {
    return {
      admins: [
        ["Management", "mdi-account-multiple-outline"],
        ["Settings", "mdi-cog-outline"],
      ],
      // process.VUE_APP_I18N_FALLBACK_LOCALE
    };
  },
  methods: {
    companyImage(companyId) {
      return this.$store.getters.getImageUrlById(companyId);
    },
  },
  computed: {
    trip() {
      return this.$store.getters.currentTripId;
    },
    userId() {
      return this.$store.state.firUser.uid;
    },
    companies() {
      const { companies } = this.$store.state;
      return Object.values(companies);
    },
  },
};
</script>
